<template>
    <div ref="modal" class="modal" @mousedown.self="mouseDown" @mouseup.self="mouseUp">
        <div ref="modalDialog" class="modal-dialog">
            <header class="modal-header">
                <h2>
                    <slot name="title"></slot>
                </h2>
                <button class="close" @click="close">✕</button>
            </header>

            <div class="modal-body">
                <slot></slot>
            </div>

            <footer v-if="$slots.footer" class="modal-footer">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",

        emits: [
            'closeModal',
        ],

        data() {
            return {
                canClose: false,
            }
        },

        methods: {
            close() {
                this.$emit('closeModal');
            },

            mouseDown() {
                this.canClose = true;
            },

            mouseUp() {
                if (this.canClose) {
                    this.close();
                }
            },

            escKey(e) {
                const keyCode = e.code;

                if(keyCode === 'Escape') {
                    this.close();
                }
            },

        },

        beforeMount() {
            window.addEventListener("keydown", this.escKey, false);

            document.body.classList.add('modal-open');
        },

        beforeUnmount() {
            window.removeEventListener("keydown", this.escKey);

            document.body.classList.remove('modal-open');
        },

    }
</script>

<style>
    .modal {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        display: flex;
        width: 100%;
        height: 100%;
        padding: 20px;
        background: rgba(0,0,0,0.35);
    }

    .modal-dialog {
        overflow: auto;
        position: relative;
        width: 600px;
        max-height: calc(100% - 80px);
        margin: auto;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 2px 20px #111;
    }

    .modal-header {
        padding: 1px;
        text-align: center;
    }

    .modal-header .close {
        position: absolute;
        z-index: 1;
        top: 8px;
        right: 13px;
        font-size: 20px;
        background: none;
        box-shadow: none;
        border: none;
        padding: 0;
        cursor: pointer;
    }


    .modal-header .close:hover {
        text-shadow: 0 0 #000;
    }

    .modal-body {
        padding: 0 25px;
    }

    .modal-footer {
        display: flex;
        justify-content: center;
        padding: 25px;
    }

    .modal-footer button {
        margin: 0 20px;
    }
</style>